import { Descope } from '@descope/react-sdk';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useSignIn } from '@portals/api/auth';
import { signedIn } from '@portals/redux/actions/auth';
import { TenantType } from '@portals/types';

export function AutoSignIn() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const signIn = useSignIn();

  return (
    <Descope
      flowId="frictionless-access-via-customer-portal"
      onSuccess={(e) => {
        signIn.mutate(
          {
            token: e.detail.sessionJwt,
            tenant_type: TenantType.Organization,
            is_support_user: true,
          },
          {
            onSuccess: (auth) => {
              dispatch(signedIn(auth));
              navigate('/');
            },
          }
        );
      }}
    />
  );
}
